import { IPagination, IPaginationDTO } from './pagination.model';

export enum GenerateQrEndpoints {
  GET_PRODUCTS_QR = '/export',
}

export enum ImportStatusEnum {
  PROCESSING = 'Processing',
  FINISHED = 'Finished',
  FAILED = 'Failed',
}

export enum IProductsQrType {
  A4_TYPE = 'labels-a4',
  SMALL_TYPE = 'labels-37х105',
  COMPACT_39_70 = 'labels-39х70',
}

export interface IQrCategory {
  active: boolean;
  id: string;
  name: string;
  position: number;
}

export interface IQrPartners {
  id: string;
  slug: string;
  title: string;
}

export interface IGeneratedQrItem {
  id: string;
  type: string;
  region: string;
  categories: IQrCategory[];
  partners: IQrPartners[];
  status: ImportStatusEnum;
  result_file: string | null;
  total_count: number;
  progress_count: number;
  error_count: number;
  error_message: string | null;
  created_at: string;
  updated_at: string;
}

// ----------------- DTOs ----------------

export interface IGeneratedQrListDTO extends Partial<IPaginationDTO> {
  limit?: number;
}
export interface ICreateProductsQrDTO {
  type?: IProductsQrType;
  region_id?: string;
  categories?: string[];
  stores?: string[];
  products?: string[];
}

// ------------ Responses --------------

export interface IGeneratedQrListResponse {
  data: IGeneratedQrItem[];
  meta: IPagination;
}
